import api from "./axios/config";

export async function getRequests() {
  try {
    const { data } = await api.get('requests');

    return { success: true, requests: data.data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function createRequest(requestData) {
  try {
    const { data } = await api.post('requests', requestData);

    return { success: true, request: data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function updateRequest(requestData) {
  try {
    const { data } = await api.patch(`requests/${requestData.id}`, requestData);

    return { success: true, request: data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function deleteRequest(requestId) {
  try {
    await api.delete(`requests/${requestId}`);
    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
}

export async function updateRequestStatus(requestId, status) {
  try {
    const { data } = await api.put(`requests/${requestId}/status`, { status });
    
    return { success: true, request: data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function createOption(optionData) {
  try {
    const { data } = await api.post('request-options', optionData);
    
    return { success: true, option: data }; 
  } catch (error) {
    return { success: false, error };
  }
} 

export async function updateOption(optionData) {
  try {
    const { data } = await api.patch(`request-options/${optionData.id}`, optionData);
    
    return { success: true, option: data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function deleteOption(optionId) {
  try {
    await api.delete(`request-options/${optionId}`);
    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
}